'use client'

import { motion, type HTMLMotionProps } from 'motion/react'
import type { ComponentPropsWithoutRef } from 'react'

import { cn } from '@repo/ui/lib/utils'

export interface DiaTextRevealProps extends ComponentPropsWithoutRef<'span'> {
  children: string
  delay?: number
  duration?: number
  stagger?: number
}

export function DiaTextReveal({
  children,
  className,
  delay = 0,
  duration = 0.6,
  stagger = 0.08,
  ...props
}: DiaTextRevealProps) {
  if (typeof children !== 'string') {
    throw new Error('DiaTextReveal: children must be a string.')
  }

  const words = children.split(' ')

  return (
    <span className={cn('relative inline-block', className)} {...props}>
      {words.map((word, i) => {
        const animation: HTMLMotionProps<'span'> = {
          initial: { opacity: 0, filter: 'blur(6px)', y: '0.2em' },
          animate: { opacity: 1, filter: 'blur(0px)', y: 0 },
          transition: { delay: delay + i * stagger, duration, ease: 'easeOut' },
        }
        return (
          <motion.span
            key={`${word}-${i}`}
            className="inline-block will-change-[transform,opacity,filter]"
            {...animation}
          >
            {word}
            {i < words.length - 1 ? ' ' : ''}
          </motion.span>
        )
      })}
    </span>
  )
}
